import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ReceiptType } from '../data/receipts.model';

export interface DownloadState {
  partnerId: string;
  receiptType: ReceiptType;
  downloadId: string;
  fileName?: string;
  progress?: number;
  startTime: number;
}

@Injectable({
  providedIn: 'root',
})
export class ReceiptDownloadStateService {
  private readonly STORAGE_KEY = 'active_download';
  private readonly activeDownloads$ = new BehaviorSubject<DownloadState>(this.loadDownload());

  getActiveDownload(): Observable<DownloadState> {
    return this.activeDownloads$.asObservable();
  }

  setDownload(download: DownloadState): void {
    this.saveDownload(download);
    this.activeDownloads$.next(download);
  }

  updateDownload(partnerId: string, updatedDownload: DownloadState): void {
    const download = this.activeDownloads$.value;
    if (download?.partnerId === partnerId) {
      this.saveDownload(updatedDownload);
    }
  }

  clearDownload(): void {
    sessionStorage.removeItem(this.STORAGE_KEY);
    this.activeDownloads$.next(null);
  }

  private loadDownload(): DownloadState {
    const stored = sessionStorage.getItem(this.STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  }

  private saveDownload(download: DownloadState): void {
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(download));
  }
}
